const AAVE = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 0H20V20H0V0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 20.0004C4.5 20.0004 0 15.5004 0 9.95041C0.05 4.45041 4.5 -0.0495873 10.05 0.000412679C15.55 0.0504127 20 4.50041 20 10.1004C19.95 15.5504 15.5 20.0004 10 20.0004Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M15.9509 14.9307L11.7476 4.77991C11.6754 4.5563 11.5346 4.36082 11.3451 4.22093C11.1555 4.08105 10.9267 4.00378 10.6907 4H10.321C10.0858 4.00461 9.85785 4.08226 9.66909 4.22208C9.48033 4.36191 9.34017 4.55694 9.26821 4.77991L7.43981 9.2034H6.05345C5.85411 9.2055 5.66359 9.28552 5.52301 9.42619C5.38242 9.56686 5.30304 9.75691 5.302 9.95532V9.96332C5.30304 10.1617 5.38242 10.3518 5.52301 10.4924C5.66359 10.6331 5.85411 10.7131 6.05345 10.7152H6.79686L5.05285 14.9307C5.01963 15.0232 5.00198 15.1205 5.00062 15.2187C4.99244 15.4261 5.06598 15.6285 5.20556 15.7826C5.27775 15.8563 5.36496 15.9137 5.46131 15.9509C5.55766 15.9882 5.66092 16.0044 5.76412 15.9986C5.92026 15.9964 6.07188 15.9461 6.19811 15.8546C6.32952 15.7567 6.43219 15.6255 6.49548 15.4747L8.42031 10.7152H9.75042C9.95046 10.7142 10.142 10.6346 10.2834 10.4938C10.4249 10.3531 10.5048 10.1624 10.5059 9.96332V9.94332C10.5048 9.74422 10.4249 9.55358 10.2834 9.4128C10.142 9.27201 9.95046 9.19246 9.75042 9.1914H9.03915L10.5059 5.54382L14.5042 15.4747C14.5675 15.6255 14.6702 15.7567 14.8016 15.8546C14.9278 15.9461 15.0795 15.9964 15.2356 15.9986C15.3395 16.005 15.4435 15.989 15.5406 15.9518C15.6377 15.9145 15.7255 15.8568 15.7982 15.7826C15.9363 15.6278 16.0084 15.4255 15.9991 15.2187C16.0042 15.1204 15.9877 15.0221 15.9509 14.9307V14.9307Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="16"
        y1="2"
        x2="10"
        y2="20.0004"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A8589A" />
        <stop offset="0.505208" stop-color="#7692B3" />
        <stop offset="1" stop-color="#5CB0C0" />
      </linearGradient>
    </defs>
  </svg>
);
export default AAVE;
